const ATIVOS = ["aguardando", "aguardando_conferencia", "em_transito"];
const PRIORITY_RANK = { vip: 0, urgente: 1, normal: 2 };
const STATUS_RANK = { aguardando: 0, aguardando_conferencia: 0, em_transito: 1, remarcar: 2, cancelada: 2, concluida: 3 };

export const isAtiva = (it) => ATIVOS.includes(it.status);
export const emRota = (it) => it.status === "aguardando_conferencia" || it.status === "em_transito";

export function computeStatusCounts(items) {
  const c = { todas: items.length, aguardando: 0, aguardando_conferencia: 0, em_transito: 0, concluida: 0, remarcar: 0, cancelada: 0, urgentes: 0 };
  items.forEach((x) => {
    if (c[x.status] !== undefined) c[x.status] += 1;
    if ((x.prioridade === "urgente" || x.prioridade === "vip") && x.status !== "concluida") c.urgentes += 1;
  });
  c.pendentes = c.aguardando + c.aguardando_conferencia + c.em_transito;
  return c;
}

// Empresas com entregas hoje + contagem só de pendentes (ordenada por count desc) — filtro por loja.
export function computeEmpresasDisponiveis(items) {
  const map = new Map();
  items.forEach((x) => {
    if (!x.empresa_id) return;
    const cur = map.get(x.empresa_id) || { id: x.empresa_id, nome: x.empresa_nome || "—", count: 0 };
    if (isAtiva(x)) cur.count += 1;
    map.set(x.empresa_id, cur);
  });
  return Array.from(map.values()).sort((a, b) => (b.count || 0) - (a.count || 0));
}

function matchesStatus(it, filterStatus) {
  if (filterStatus === "urgentes") return (it.prioridade === "urgente" || it.prioridade === "vip") && it.status !== "concluida";
  if (filterStatus === "pendentes") return isAtiva(it);
  return filterStatus === "todas" || it.status === filterStatus;
}

function matchesSearch(it, qText, qDigits, lookup) {
  if (!qText) return true;
  const campos = [it.cliente_nome, it.numero_pedido, it.numero_pedido_receita, it.numero_pedido_revenda,
    lookup.bai[it.bairro_id], lookup.reg[it.regiao_id]].map((v) => (v || "").toLowerCase());
  if (campos.some((v) => v.includes(qText))) return true;
  // pedidos_multiplos: o entregador acha a entrega digitando QUALQUER um dos números internos
  const pedsMulti = Array.isArray(it.pedidos_multiplos) ? it.pedidos_multiplos.map((p) => String(p || "").toLowerCase()) : [];
  if (pedsMulti.some((p) => p.includes(qText))) return true;
  const tel = (it.cliente_telefone || "").replace(/\D/g, "");
  return !!(qDigits && qDigits.length >= 3 && tel.includes(qDigits));
}

// Filtra por loja/status/busca e ordena: sequência da rota (quando definida) entre ativas,
// depois prioridade (vip > urgente > normal) e status.
export function filterAndSortEntregas(items, { search, filterStatus, filterEmpresa, lookup }) {
  const qText = search.trim().toLowerCase();
  const qDigits = qText.replace(/\D/g, "");
  const list = items.filter((it) =>
    (filterEmpresa === "all" || it.empresa_id === filterEmpresa) && matchesStatus(it, filterStatus) && matchesSearch(it, qText, qDigits, lookup));
  const hasOrdem = list.some((x) => x.ordem != null && emRota(x));
  list.sort((a, b) => {
    const sa = STATUS_RANK[a.status] ?? 5, sb = STATUS_RANK[b.status] ?? 5;
    if (hasOrdem && sa <= 1 && sb <= 1) {
      const oa = a.ordem ?? 9999, ob = b.ordem ?? 9999;
      if (oa !== ob) return oa - ob;
    }
    const pa = PRIORITY_RANK[a.prioridade] ?? 2, pb = PRIORITY_RANK[b.prioridade] ?? 2;
    if (pa !== pb) return pa - pb;
    return sa - sb;
  });
  return list;
}
